export enum ExternalRespondentStatus {
  DO_NOT_DISTURB = "DO_NOT_DISTURB"
}
